'use client';

import { useSearchParams } from 'next/navigation';
import { Suspense, useEffect } from 'react';

import { captureAttribution } from './attribution';

function Capture() {
    const search = useSearchParams().toString();

    // Re-runs on client-side navigation too: a tagged link followed inside the app changes the search params
    // without a reload. captureAttribution is last-tagged-visit-wins and a no-op for the same landing, so a
    // re-render never replaces a newer capture with an older one.
    useEffect(() => {
        captureAttribution(search);
    }, [search]);

    return null;
}

/** Renders nothing; remembers the utm_* parameters of the landing URL for the cart created later. */
export default function AttributionCapture() {
    // useSearchParams opts the page into client rendering up to the nearest Suspense boundary; keep it local.
    return (
        <Suspense fallback={null}>
            <Capture />
        </Suspense>
    );
}
